import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import Loader from './../shared/loader'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import Pagination from './../shared/pagination'
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
export default {
	name: 'stocktransfer',
	components: {
		BasicSelect,
		Paginate,
		Pagination,
		DatePicker,
		Loader
	},
	data: function() {
		return {
			// totalRows:0,
			// currentPage: 0,
			selectedmerchant:{value:'',text:''},
			merchantList:[],
			resultCount: 0,
			viewRTOmodal: false,
			rtoNo: '',
			recived_qty: '',
			searchFlag: false,
			addRTOmodal: false,
			isDisabled: false,
			RTOaction: '',
			listRTOData: [],
			isLoading: false,
			rtoidDetails: [],
			listRTOproductData: [],
			listRTOproduct1Data: [],
			toCheckShowRowIndex: '',
			Details: [],
			viewRTOmodal: false,
			contentVisible:false,
			useremail: '',
			status: '', // listRTOproductData() {
			awbno: '',
			transporter: '',
			orderid: '',
			rtoid: '',

			rtoProductDetails1: [],

			saveGR: {
				awbno: '',
				rtoid: '',
				orderid: '',
				transporter: '',
			},

			listClientData: [],
			listWarehouseData: [],
			pageno: 0,
			totalPage: 0,
			pageLimit: 5,
			totalPage: 0,
			totalRows:0,
			currentPage: 1,
			pageLimit:5,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			showSelectMerchant:false,
			ClientErr: '',
			WarehouseErr: '',
			listMerchantData:[],
			MerchantList: [],
			merchantid: '',
			merchant: '',
			rtostatuslist:[
				{
	        'status': 'Received'
	      },{
	        'status': 'rackin'
	      },{
	        'status': 'WHInscan'
	      },
			],
			merchantnameFlt:''
		}
	},

	created: function() {},
	computed: {},

	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail.email;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
		}
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant =true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				// this.getWarehouseList();
				this.getMerchantList();
				this.showSelectWarehouse = true;
				this.showSelectMerchant =true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant =true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},
	methods: {
		selectMerchant(data){
			this.selectedmerchant = data;
			this.merchantnameFlt = data.value;
			console.log(this.selectedmerchant,"merch")
		  },
		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;

		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listWarehouseData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// 	}
		// },

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;

		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listClientData = result.data.data;
		// 		}, error => {
		// 			console.error(error);
		// 		});
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client ||this.clientid == this.client) {
		// 		this.clientid = this.client;
		// 		this.listWarehouseData = []
		// 		this.merchantList=[]
		// 		this.selectedmerchant={}
		// 		this.getWarehouseList();
		// 		this.getMerchantList();
		// 		this.merchantnameFlt ='';
		// 		this.warehouse = '';
		// 		if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 			this.warehouse = this.warehouseid = '';
		// 		}
		// 	}

		// 	this.clientid = this.client;
		// 	if (this.clientid) {
		// 		this.resetFormData();
		// 		if (this.warehouseid) {
		// 			//this.getRTOListSearch();
		// 		} else {
		// 			this.getWarehouseList();
		// 		}
		// 	}
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			//this.getRTOListSearch();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		//open new pop up for saving the rto
		saveDataForGR(data) {

			if (data.grstatus == 1) {
				this.$alertify.error(this.$t('rejectlistrto.grAlreadyDone'));
			} else {
				this.RTOaction = 'add',
					this.addRTOmodal = true,
					this.$validator.reset();
				this.errors.clear();
				this.saveGR = data;
				this.getRTOProductData();
			}

		},

		// pop up to view rto data
		viewRTOdata(data) {
			if (data.grstatus == 0) {
				this.$alertify.error(this.$t('rejectlistrto.completeGRProcess'));
				return false;
			} else {
				// this.viewRTOmodal = true,
				this.contentVisible=false;
					this.saveGR = data;

				this.getGRProductData();
				this.toCheckShowRowIndex = Number(this.listRTOData.indexOf(data))
				for (var i = 0; i < this.listRTOData.length; i++) {
					if (i != this.toCheckShowRowIndex || this.listRTOData[i].contentVisible==true) {
						this.listRTOData[i].contentVisible = false
					}
					else{
						this.listRTOData[i].contentVisible = true

					}
				}

			}

		},
		//to close add (new) form
		closeAddRTOModal() {
			this.addRTOmodal = false
		},
		//to close edit form
		closeviewRTOModal() {
			this.viewRTOmodal = false
		},

		//to close add (new) form
		closeviewRTOmodal() {
			this.viewRTOmodal = false
		},

		getRTOProductData() {
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				offset: this.pageno,
				limit: 10,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				awbno: this.saveGR.awbno,
				clientid: localStorage.getItem("selectedClient"),
				transporter : this.saveGR.transporter,

			})
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'rtoproductlist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.rtoProductDetails1 = [];
					this.listRTOproductData = result.data.data;
					this.listRTOproduct1Data = result.data.data;
					for (i = 0; i < this.listRTOproduct1Data.length; i++) {
						this.rtoProductDetails1.push({
							acceptquantity: '',
							rejectquantity: 0,
							receivedquantity: '',
							shortquantity : 0,
							rejectreason: '',
							mrp: this.listRTOproduct1Data[i].mrp,
							productid: this.listRTOproduct1Data[i].productid,
							lotcontrol: this.listRTOproduct1Data[i].lotcontrol,
							quantity: this.listRTOproduct1Data[i].quantity,
							orderitemsequence: this.listRTOproduct1Data[i].orderitemsequence,
						});
					}
					this.isLoading = false;
				})
		},

		getGRProductData() {
			var i = 0;
			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				offset: this.pageno,
				limit: 10,
				warehouseid:localStorage.getItem("selectedWarehouse"),
				awbno: this.saveGR.awbno,
				clientid: localStorage.getItem("selectedClient"),
				transporter : this.saveGR.transporter,

			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getGRProductDetails',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					this.contentVisible = true;
					this.rtoProductDetails1 = [];
					this.listRTOproductData = result.data.data;
					this.listRTOproduct1Data = result.data.data;

					for (i = 0; i < this.listRTOproduct1Data.length; i++) {
						this.rtoProductDetails1.push({
							acceptquantity: '',
							rejectquantity: 0,
							receivedquantity: '',
							rejectreason: '',
							productid: this.listRTOproduct1Data[i].productid,
							lotcontrol: this.listRTOproduct1Data[i].lotcontrol,
							quantity: this.listRTOproduct1Data[i].quantity,
							recived_qty: this.listRTOproduct1Data[i].recived_qty,
							short_quantity: this.listRTOproduct1Data[i].short_quantity,
							accepted_qty: this.listRTOproduct1Data[i].accepted_qty,
							rejected_qty: this.listRTOproduct1Data[i].rejected_qty,
							rejected_reason: this.listRTOproduct1Data[i].rejected_reason,
						});
					}
				})
		},

		searchRTOData() {
			this.currentPage = 1;
			// this.totalPage = 0;
			this.getRTOListSearch();
		},
		getRTOListSearch() {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))

				// this.totalPage = 0;
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				// this.totalPage = 0;
				return false;
			}

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			// this.resultCount = 0;
			this.searchFlag = true;
			this.listRTOData = [];
			// this.totalRows=0;
			this.isLoading = true;
			this.input = ({
				offset: (this.currentPage - 1) * 5,
				limit: this.pageLimit,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				awbno: this.awbno,
				merchantid:this.merchantnameFlt,
				transporter: this.transporter,
				status: this.status,
				orderid: this.orderid,
				rtoid: this.rtoid,
				clientid: localStorage.getItem("selectedClient")
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'rtolist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listRTOData = result.data.data
					this.resultCount = result.data.count
					this.totalRows = result.data.count

					if (result.data.count == 0){
						this.totalPage = 0
						this.currentPage = 1
					}else if (this.totalRows <= this.pageLimit) {
						this.totalPage = 1
					} else {
						this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},
		//to reset search form
		resetFlt() {
			this.totalRows=0;
			this.isLoading = false;
			this.awbno = '';
			this.transporter = '';
			this.status = '';
			this.orderid = '';
			this.rtoid = '';
			// this.clientid = '';
			this.searchFlag = false;
			// this.client = "";
			// this.warehouse = "";
			this.listRTOData = [];
			this.totalPage = 0;
			// this.merchantList=[]
			this.selectedmerchant={}
			this.WarehouseErr = '';
			this.ClientErr = '';
		},

		resetFormData() {
			this.totalRows=0;
			this.awbno = '';
			this.transporter = '';
			this.status = '';
			this.orderid = '';
			this.rtoid = '';
			this.searchFlag = false;
			this.pageno = 0;
			this.totalPage = 0;
			this.listRTOData = [];
			// this.merchantList=[]
			this.selectedmerchant={}
			this.WarehouseErr = '';
			this.ClientErr = '';
		},

		saveRtoMultiple() {
			var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
			// Now looping throught to make validations
			var i = 0;
			for (i = 0; i < this.rtoProductDetails1.length; i++) {

				if (isNaN(this.rtoProductDetails1[i].receivedquantity) || isNaN(this.rtoProductDetails1[i].acceptquantity) || isNaN(this.rtoProductDetails1[i].rejectquantity) || isNaN(this.rtoProductDetails1[i].shortquantity) || this.rtoProductDetails1[i].receivedquantity == "" || this.rtoProductDetails1[i].acceptquantity == "") {

					this.$alertify.error(this.$t('rejectlistrto.enterNumericVal'));
					return false;
				// } else if (this.rtoProductDetails1[i].acceptquantity < 0 || this.rtoProductDetails1[i].rejectquantity < 0 || this.rtoProductDetails1[i].shortquantity < 0 || this.rtoProductDetails1[i].receivedquantity < 1) {
				} else if (this.rtoProductDetails1[i].acceptquantity < 0 || this.rtoProductDetails1[i].rejectquantity < 0 || this.rtoProductDetails1[i].shortquantity < 0 ) {
					this.$alertify.error(this.$t('rejectlistrto.enterValidNumericVal'));
					return false;
				} else {
					if (parseInt(this.rtoProductDetails1[i].receivedquantity)+parseInt(this.rtoProductDetails1[i].shortquantity) != parseInt(this.rtoProductDetails1[i].quantity)) {
						this.$alertify.error(this.$t('rejectlistrto.sumOfReceivedShortQty'));
						return false;
					}

					if (parseInt(this.rtoProductDetails1[i].receivedquantity) != parseInt(this.rtoProductDetails1[i].acceptquantity) + parseInt(this.rtoProductDetails1[i].rejectquantity)) {

						this.$alertify.error(this.$t('rejectlistrto.receivedAcceptedRejectedQty'));
						return false;
					}

					if (this.rtoProductDetails1[i].rejectquantity > 0) {
						if (this.rtoProductDetails1[i].rejectreason == "") {
							this.$alertify.error(this.$t('rejectreason.rejectReasonError'));
							return false;
						}
					}
				}
			}


			this.input = ({
				awbno: this.saveGR.awbno,
				orderid: this.saveGR.orderid,
				shippingcompany: this.saveGR.transporter,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				useremail: this.useremail,
				rtoProductDetails: this.rtoProductDetails1,
				rtoid: this.saveGR.rtoid,
				clientid: localStorage.getItem("selectedClient")
			})
      //console.log(this.input);return false;
			this.isLoading = true;

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'rtoSaveGrMultiple',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.addRTOmodal = false;
					this.isLoading = false;
					this.$alertify.success(this.$t('rejectlistrto.grDone'));
					this.getRTOListSearch();
				}, error => {
					console.error(error)
				})
		},
		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.pageLimit;
		// 	this.getRTOListSearch();
		// },
		onPageChange(page) {
		  this.currentPage = page;
		  this.getRTOListSearch()
		},
		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid')
			}).catch(() => {
				console.log('errors exist')
			});
		},
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						this.merchantList.push({
							value:'',text: this.$t('common.selectMerchantPlaceHolder')}
					   )
					  for (var i = 0; i < this.listMerchantData.length; i++) {
						  this.merchantList.push({
							'value': this.listMerchantData[i].merchantid,
							'text': this.listMerchantData[i].merchantname
						  });
						}
					}
				}, error => {
					console.error(error)
				})
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/rto/rto.component.js